import React from 'react';

function AnythingDetailsDate({ anything, ...rest }) {
  const { value1, value2 } = anything;
  let date1 = Date.parse(value1);
  let date2 = Date.parse(value2);

  return (
    <div {...rest}>
      <h5>
        {isNaN(date1) ? value1 : new Date(date1).toLocaleDateString('sv')}
        {isNaN(date2)
          ? `: ${value2}`
          : ` — ${new Date(date2).toLocaleDateString('sv')}`}
      </h5>
    </div>
  );
}

export default AnythingDetailsDate;
